// 关闭时限
const TIME_LIMIT = {
    ONCE: 'once', // 次
    DAY: 'day', // 天
    FOREVER: 'forever' // 永久
};

// 组件名
const CMP_NAME = 'fixed-box';
const CMP_NAME_CLOSE_BTN = 'fixed-box/close-btn';
const HIDE_TYPE = {
    NONE: 'none',
    FIRST_SCREEN: 'first_screen',
    CMP_IN_SCREEN: 'cmp_in_screen'
};
const DISPLAY_TYPE = {
    // 显示
    DISPLAY: 'display',
    // 隐藏
    HIDDEN: 'hidden',
    // 关闭
    CLOSE: 'close',
};

export { TIME_LIMIT, CMP_NAME, CMP_NAME_CLOSE_BTN, HIDE_TYPE, DISPLAY_TYPE };
